import { render, staticRenderFns } from "./luckDraw.vue?vue&type=template&id=f172bcd2&scoped=true&"
import script from "./luckDraw.vue?vue&type=script&lang=js&"
export * from "./luckDraw.vue?vue&type=script&lang=js&"
import style0 from "./luckDraw.vue?vue&type=style&index=0&id=f172bcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f172bcd2",
  null
  
)

export default component.exports